import React, { useState, useContext } from 'react';
import { Button } from "flowbite-react";
import { dropdownData } from "../DropdownData";
import { useNavigate, useSearchParams } from "react-router-dom";
import { searchQueries } from "../../routes"

interface ListData {
    name:string;
}

const DropDown = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [showList, setShowList] = useState(false);
    const [firstList, setFirstList] = useState<boolean>(false);

    const list: ListData[] = dropdownData.list;
    const searchContext = useContext(searchQueries)

    function mouseOver(){
        setShowList(true);
        setFirstList(true);
        setFirstList(true);
    }
    function mouseOut(){
        setFirstList(false);
        setShowList(false);
    }

    const handleCategoryNavigation = (category: string) => {
        setShowList(false);
        handleMakeQuery('cat', category)
        searchContext?.handleSearch({category: category})
    }

    const handleMakeQuery = (name: string, value: string) => {
        let testQuery:any = {};
        for (const [key, value] of searchParams){
            testQuery[key] = value
        }
        testQuery[name] = value

        let searchQuery = '/search/?'
        for (const property in testQuery) {
            searchQuery = searchQuery + `&${property}=${testQuery[property]}`
        }
        navigate(searchQuery);
    }

    return (
        <div className="container">
            <div className="relative -left-4">
                <Button className={showList ? "!bg-transparent text-secondary !rounded-none !border-none !right-0 hover:!bg-transparent focus:!ring-transparent" : "!bg-transparent hover:text-secondary text-primary !rounded-none !border-none !right-0 bg-white hover:!bg-white focus:!ring-transparent"} color="light" onMouseOver={mouseOver} onMouseOut={mouseOut}>
                    Categories
                </Button>
            </div>

            <div className="absolute z-10 top-[30px] transition-all h-auto " onMouseOver={mouseOver} onMouseOut={mouseOut}>
                <div className="h-7 bg-transparent cursor-pointer"></div>
                {
                    showList  &&
                    <div className='w-[15rem] bg-white h-full border shadow-md' >
                        {
                            firstList &&
                            <div className="w-full py-3">
                                {
                                    list.map((item: any, idx:number) => (
                                        <div  key={idx} onClick={() => handleCategoryNavigation(item?.name)}>
                                            <li className='px-1 py-[7px] mx-3 flex text-primary justify-between items-center hover:text-secondary cursor-pointer'>
                                                <span className="text-sm font-normal">{item?.name}</span>
                                            </li>
                                        </div>
                                    ))
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    );
};

export default React.memo(DropDown);
